import { apiV1, apiV2 } from "@/store";
import axios from "axios";
import router from "@/router";

const state = {
  access_token: sessionStorage.getItem("access_token") || null,
  refresh_token: sessionStorage.getItem("refresh_token") || null,
  expires_at: Number(sessionStorage.getItem("token_expires_at")) || null,
  sessionTimeoutInterval: null
};

const actions = {
  login: ({ commit, dispatch }, payload) => {
    const data = {
      email: payload.email,
      password: payload.password
    };

    apiV1.post(`/auth/login`, data)
      .then(async(resp) => {
        await commit("tokenSuccess", resp.data);
        router.push({ name: "arDashboard" }).catch(() => {});
      })
      .catch((err) => {
        dispatch("handleError", err, { root: true });
      });
  },

  extendSession: ({ commit, state }) => {
    apiV1.post(`/auth/extend-session`, { refresh_token: state.refresh_token })
      .then((resp) => {
        commit("tokenSuccess", resp.data);
      })
      .catch(() => {
        // @todo wtf do we do now?
      });
  },

  startSession: ({ commit, dispatch, state }) => {
    if (!state.sessionTimeoutInterval) {
      const interval = setInterval(() => {
        const now = Math.floor(Date.now() / 1000);

        // if token is less than 5 minutes from timing out, refresh it
        if (now + 300 > state.expires_at) {
          dispatch("extendSession");
        }
      }, 1000 * 60); // check every minute if we need to refresh the token

      commit("setSessionInterval", interval);
    }
  },

  logout: async({ commit, dispatch }) => {
    await commit("clearAuth");
    await commit("clearSessionInterval");
    await commit("resetInit");
    await dispatch("clearUser");
    router.push("/login").catch(() => {});
  }
};

const mutations = {
  tokenSuccess: (state, response) => {
    const access_token = "Bearer " + response.access_token;
    const now = Math.floor(Date.now() / 1000);

    state.access_token = access_token;
    state.refresh_token = response.refresh_token;
    state.expires_at = response.expires_in + now;

    sessionStorage.setItem("access_token", access_token);
    sessionStorage.setItem("refresh_token", response.refresh_token);
    sessionStorage.setItem("token_expires_at", state.expires_at);

    apiV1.defaults.headers.common["Authorization"] = access_token;
    apiV2.defaults.headers.common["Authorization"] = access_token;
    axios.defaults.headers.common["Authorization"] = access_token;

    return Promise.resolve(true);
  },

  ssoLogin: (state, payload) => {
    sessionStorage.setItem("access_token", payload.accessToken);
    sessionStorage.setItem("refresh_token", payload.refreshToken);
    sessionStorage.setItem("token_expires_at", payload.expires);

    apiV1.defaults.headers.common["Authorization"] = payload.accessToken;
    apiV2.defaults.headers.common["Authorization"] = payload.accessToken;
    axios.defaults.headers.common["Authorization"] = payload.accessToken;

    state.access_token = payload.accessToken;
    state.refresh_token = payload.refreshToken;
    state.expires_at = payload.expires;

    return Promise.resolve(true);
  },

  clearAuth: (state) => {
    sessionStorage.clear(); // @todo does this actually work?
    state.access_token = state.refresh_token = state.expires_at = null;

    return Promise.resolve(true);
  },

  setSessionInterval: (state, interval) => {
    state.sessionTimeoutInterval = interval;
  },

  clearSessionInterval: (state) => {
    clearInterval(state.sessionTimeoutInterval);
    state.sessionTimeoutInterval = null;
  }
};

export default {
  state,
  actions,
  mutations
};
